import Cookies from 'js-cookie';

interface IInitProps {
  specialKeys: readonly string[], rootKey: string
}

const rootKeyPrefix = '__ordering_website_special_local_';

class StorageHelper {

  private static specialKeys: Set<string> = new Set();
  private static root: string | null = null;
  private static now = new Date(); // 初始引用实例拿时间
  private static expiry = this.now.getTime() + 7 * 24 * 60 * 60 * 1000; // 可存储时间

  static init({ specialKeys, rootKey }: IInitProps): void {
    this.specialKeys = new Set(specialKeys)
    this.root = rootKeyPrefix + String(rootKey)
    
    if (typeof window === 'undefined') return // 防止服务端调用

    /** 遍历一下local，拿到项目里特殊存储的项目并识别该项是否已经过期 */
    for (let i = 0; i < localStorage?.length; i++) {
      const key = localStorage.key(i); // 拿一下当前的key

      if (!key?.startsWith(rootKeyPrefix)) continue // 如果不包含项目特殊前缀则跳过

      const itemStr = localStorage.getItem(key);

      if (!itemStr) continue // 可能存了个null ｜ undefined

      const item = JSON.parse(itemStr);

      // 如果超出存储时间就干掉
      if (this.now.getTime() > item?.expiry) {
        localStorage.removeItem(key)
      }
      
    }
  }

  private static specialSetItem(key: string, value: any): void {
    if (this.root) {

      const rootData = JSON.parse(localStorage.getItem(this.root) || '{}');
      if (!rootData) return localStorage.setItem(key, JSON.stringify(value)); // 如果特殊存储项不存在，则直接把value存local

      const data = rootData ? rootData : {};

      /* 
        把存的value放data里
        格式： xxxxxx: { 存的value，过期时间 }
      */
      data[key] = value;
      data.expiry = this.expiry
      localStorage.setItem(this.root, JSON.stringify(data))
    }
  }

  private static specialGetItem(key: string): any {
    if (this.root) {
      const rootData = JSON.parse(localStorage.getItem(this.root) || '');
      if (!rootData) return JSON.parse(localStorage.getItem(key) || '')?.value?.[key];
      return rootData?.[key];
    }
  }


  static getPrefixKeyForStoreId(key: string) {
    
  }

  static getItem(key: string): any {
    try {
      if (typeof window !== 'undefined') {
        const orgId = Cookies.get('__orgId');


        if (this.specialKeys?.has(key)) {
          return this.specialGetItem(key)
        }

        key = `${orgId}_${key}`;

        const value = localStorage.getItem(key);
        if (value !== null) {
          return JSON.parse(value);
        }
      }
    } catch {
      return null;
    }
  }

  static setItem(key: string, value: any): void {
    if (typeof window !== 'undefined') {
      const orgId = Cookies.get('__orgId');

      if (this.specialKeys?.has(key)) {
        this.specialSetItem(key, value)
        return
      }

      key = `${orgId}_${key}`;
      localStorage.setItem(key, JSON.stringify(value, null));
    }
  }
  static delete(key: string): void {
    if (typeof window !== 'undefined') {
      const orgId = Cookies.get('__orgId');
      key = `${orgId}_${key}`;

      if (this.specialKeys?.has(key)) {
        const rootData = JSON.parse(localStorage.getItem(this.root || '') || '');
        rootData?.delete(key);
        return
      }
      localStorage.removeItem(key);
    }
  }
  
  static clear(): void {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }
}
export default StorageHelper;